import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../common.service';
import { ToastrService } from 'ngx-toastr';
import { DefaultComponent } from '../../layout/default/default.component';
declare var $: any;
@Component({
  selector: 'app-festival-photos-add',
  templateUrl: './festival-photos-add.component.html',
  styleUrls: ['./festival-photos-add.component.css']
})
export class FestivalPhotosAddComponent implements OnInit, AfterViewInit {
  imageURL1: string;
  news_date = localStorage.getItem('EntryDate');
  NewsData: any = [];
  news_id: any = 0;
  NewsImageURL = environment.baseUrl;
  imageURL: string;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public toastr: ToastrService,
    public CommonService: CommonService,
    public DefaultComponent: DefaultComponent
  ) {
    this.route.params.subscribe(params => this.news_id = params.news_id);
    var param = { news_id: this.news_id };
    if (this.news_id) {
      this.CommonService.getFestivalPhotoDetail(param).subscribe((data) => {
        if (data['status']) {
          this.NewsData = data['update_data']
          if (this.NewsData.image != '') {
            this.imageURL = this.NewsImageURL + '/festival_photo/' + this.NewsData.image;
          }
        } else {
          if (data.token_expire) {
            localStorage.removeItem('login_token');
            this.router.navigate(['/']);
          } else {
            this.router.navigate(['/dashboard']);
          }
        }
      });
    }
  }
  imageValidation(event, id) {
    const file = (event.target as HTMLInputElement).files[0];
    var mimeType = file.type;
    if (mimeType.match(/image\/*/) == null) {
      $("#image" + id).val('');
      this.toastr.error("Only image are supported.");
      return;
    }
  }
  submit_form() {
    var routers = this.router;
    var th = this;
    $.validate({
      onSuccess: function () {
        th.DefaultComponent.loaderShow();
        //$('.btn-success').attr('disabled', true);
        var form = $("#festival_photo_form");
        var fd = new FormData(form[0]);
        var token = localStorage.getItem('login_token');
        $.ajax({
          url: environment.FestivalPhotoBaseUrl + 'add_festival_photo',
          method: 'POST',
          data: fd,
          headers: {
            'Authorization': token
          },
          contentType: false,
          processData: false,
          dataType: 'json',
          success: function (res) {
            th.DefaultComponent.loaderHide();
            if (res.status) {
              th.toastr.success(res.message)
              routers.navigate(['/festival-photo-list']);
            } else {
              if (res.token_expire) {
                localStorage.removeItem('login_token');
                routers.navigate(['/']);
              }
              else {
                th.toastr.error(res.message)
              }
            }
            $('.btn-success').attr('disabled', false);
          }
        });
        return false;
      }
    });
  }
  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    setTimeout(function () {
      $('#datepicker').datepicker({
        format: "dd-mm-yyyy",
        autoclose: true,
        orientation: "top",
        todayHighlight: true,
        startDate: new Date(),
      }).on('changeDate', function (selected) {
        var minDate = new Date(selected.date.valueOf());
        $('#datepicker1').datepicker('setStartDate', minDate);
      });
      $('#datepicker1').datepicker({
        format: "dd-mm-yyyy",
        autoclose: true,
        orientation: "top",
        todayHighlight: true,
      }).on('changeDate', function (selected) {
        var maxDate = new Date(selected.date.valueOf());
        $('#datepicker').datepicker('setEndDate', maxDate);
      });
    }, 500);
  }
}
